module.exports = __webpack_public_path__ + "static/water-taxi.42baef99.png";